import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from './modules/main/header/header.component';
import { FooterComponent } from './modules/main/footer/footer.component';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './modules/main/main.component';
import { MenuSidebarComponent } from './modules/main/menu-sidebar/menu-sidebar.component';
import { ActionReducerMap, StoreModule, combineReducers } from '@ngrx/store';
import { uiReducer } from './store/ui/reducer'
import { authReducer } from './store/auth/reducer'
import { AuthActions } from './store/auth/actions';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { LoaderComponent } from './pages/loader/loader.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginComponent } from './modules/login/login.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { ToastrModule } from 'ngx-toastr';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { HttpClientModule } from '@angular/common/http';
import { RecoverPasswordComponent } from './modules/recover-password/recover-password.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatTableModule } from '@angular/material/table' 
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ConfirmationDialogComponent } from './pages/confirmation-dialog/confirmation-dialog.component';
import { VerificationCodeComponent } from './modules/verification-code/verification-code.component';
import { CollegeAddEditComponent } from './pages/College-list/college-add-edit/college-add-edit.component'; 
import { CollegeListComponent } from './pages/College-list/college-list.component';
import { CollegeBatchListComponent } from './pages/college-batch-list/college-batch-list.component';
import { CollegeBatchAddEditComponent } from './pages/college-batch-list/college-batch-add-edit/college-batch-add-edit.component';
import { CollegeViewComponent } from './pages/College-list/college-view/college-view.component';
import { CollegeBatchViewComponent } from './pages/college-batch-list/college-batch-view/college-batch-view.component';
import { StudentComponent } from './pages/student/student.component';
import { DropdownDialogComponent } from './pages/dropdown-dialog/dropdown-dialog.component';
import { QuestionSetComponent } from './pages/question-set/question-set.component';
import { QuestionSetAddEditComponent } from './pages/question-set/question-set-add-edit/question-set-add-edit.component';
import { QuestionSetViewComponent } from './pages/question-set/question-set-view/question-set-view.component';
import { EditProfileComponent } from './pages/edit-profile/edit-profile.component';
import { TestComponent } from './pages/test/test.component';
import { TestAddEditComponent } from './pages/test/test-add-edit/test-add-edit.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import {NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { UserListComponent } from './pages/user-list/user-list.component';
import { UserAddEditComponent } from './pages/user-list/user-add-edit/user-add-edit.component';
import { UserViewComponent } from './pages/user-list/user-view/user-view.component';
import { ReportProblemComponent } from './pages/report-problem/report-problem.component';
import { ReportProblemViewComponent } from './pages/report-problem/report-problem-view/report-problem-view.component';
import { QuestionListComponent } from './pages/questions/question-list/question-list.component';
import { QuestionEditComponent } from './pages/questions/question-edit/question-edit.component';
import { QuestionViewComponent } from './pages/questions/question-view/question-view.component';
import { QuestionAddComponent } from './pages/questions/question-add/question-add.component';
import { DeleteDialogboxComponent } from './pages/delete-dialogbox/delete-dialogbox.component';
import { StatusDialogboxComponent } from './pages/status-dialogbox/status-dialogbox.component';
import { AlertDialogComponent } from './pages/alert-dialog/alert-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CompanyListComponent } from './pages/company-list/company-list.component';
import { CompanyAddEditComponent } from './pages/company-list/company-add-edit/company-add-edit.component';
import { CompanyViewComponent } from './pages/company-list/company-view/company-view.component';
import { DisplayProfileComponent } from './pages/display-profile/display-profile.component';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { CompanyUserComponent } from './pages/company-user/company-user.component';
import { CompanyUserAddEditComponent } from './pages/company-user/company-user-add-edit/company-user-add-edit.component';
import { CompanyUserViewComponent } from './pages/company-user/company-user-view/company-user-view.component';
import { TestStudentViewComponent } from './pages/test/test-student-view/test-student-view.component';
import { TestDetailComponent } from './pages/test/test-detail/test-detail.component';
import { StudentResultComponent } from './pages/test/student-result/student-result.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { StudentAddComponent } from './pages/student/student-add/student-add.component';
import { TestDialogComponent } from './pages/test-dialog/test-dialog.component';
import { RestartExamComponent } from './pages/restart-exam-dialogbox/restart-exam/restart-exam.component';
import { PendingStudentComponent } from './pages/test/pending-student/pending-student.component';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { JobComponent } from './pages/job/job.component';
import { AddJobComponent } from './pages/job/add-job/add-job.component';
import { JobTypeComponent } from './pages/job/job-type/job-type.component';
import { jobViewComponent } from './pages/job/Job-view/Job-view.component';
import {MatIconModule} from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { StudentViewComponent } from './pages/student/student-view/student-view.component';
import { CompanyProfileComponent } from './pages/company-profile/company-profile/company-profile.component';
import { SaveTestDialogComponent } from './pages/save-test-dialog/save-test-dialog.component';
import { ParentTechnologyPreferenceComponent } from './pages/Technology-Preference/parent-technology-preference/parent-technology-preference.component';
import { ChildTechnologyPreferenceComponent } from './pages/Technology-Preference/child-technology-preference/child-technology-preference.component';
import { AddParentTechnologyPreferenceComponent } from './pages/Technology-Preference/add-parent-technology-preference/add-parent-technology-preference.component';
import { AddChildTechnologyPreferenceComponent } from './pages/Technology-Preference/add-child-technology-preference/add-child-technology-preference.component';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { UploadQuestionDialogBoxComponent } from './pages/questions/upload-question-dialog-box/upload-question-dialog-box.component';
import { SaveStudentConfirmationDialogComponent } from './pages/save-student-confirmation-dialog/save-student-confirmation-dialog.component';
import { StudentListComponent } from './pages/test/test-add-edit/student-list/student-list.component';
import { DuplicateQuestionDialogBoxComponent } from './pages/questions/duplicate-question-dialog-box/duplicate-question-dialog-box.component';

const reducers: ActionReducerMap<any, AuthActions> = {
  ui: uiReducer,
  auth: authReducer
};
const appDateFormat = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    MainComponent,
    MenuSidebarComponent,
    MenuItemComponent,
    LoaderComponent,
    LoginComponent,
    ForgotPasswordComponent,
    RecoverPasswordComponent,
    PageNotFoundComponent,
    ChangePasswordComponent,
    ConfirmationDialogComponent,
    VerificationCodeComponent,
    CollegeListComponent,
    CollegeAddEditComponent,
    CollegeBatchListComponent,
    CollegeBatchAddEditComponent,
    CollegeViewComponent,
    CollegeBatchViewComponent,
    StudentComponent,
    DropdownDialogComponent,
    QuestionSetComponent,
    QuestionSetAddEditComponent,
    QuestionSetViewComponent,
    EditProfileComponent,
    TestComponent,
    TestAddEditComponent,
    UserListComponent,
    UserAddEditComponent,
    UserViewComponent,
    ReportProblemComponent,
    ReportProblemViewComponent,
    QuestionListComponent,
    QuestionEditComponent,
    QuestionViewComponent,
    QuestionAddComponent,
    DeleteDialogboxComponent,
    StatusDialogboxComponent,
    AlertDialogComponent,
    CompanyListComponent,
    CompanyAddEditComponent,
    CompanyViewComponent,
    DisplayProfileComponent,
    CompanyUserComponent,
    CompanyUserAddEditComponent,
    CompanyUserViewComponent,
    TestStudentViewComponent,
    TestDetailComponent,
    StudentResultComponent,
    StudentAddComponent,
    TestDialogComponent,
    RestartExamComponent,
    PendingStudentComponent,
    JobComponent,
    AddJobComponent,
    JobTypeComponent,
    jobViewComponent,
    StudentViewComponent,
    CompanyProfileComponent,
    SaveTestDialogComponent,
    ParentTechnologyPreferenceComponent,
    ChildTechnologyPreferenceComponent,
    AddParentTechnologyPreferenceComponent,
    AddChildTechnologyPreferenceComponent,
    UnauthorizedComponent,
    UploadQuestionDialogBoxComponent,
    SaveStudentConfirmationDialogComponent,
    StudentListComponent,
    DuplicateQuestionDialogBoxComponent
  ],
  imports: [
    BrowserModule,
    MatSelectModule,
    AppRoutingModule,
    FormsModule,
    CKEditorModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
    MatIconModule,
    NgxMatSelectSearchModule,
    StoreModule,
    FormlyBootstrapModule,
    StoreModule.forRoot(reducers),
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    ToastrModule.forRoot({
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true
    }),
    MatSnackBarModule,
    HttpClientModule,
    NgOtpInputModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaterialTimepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatStepperModule,
    MatSlideToggleModule,
    FormlyModule.forRoot({
      validationMessages: [
        { name: 'required', message: 'This field is required' },
      ],
    }),
  ],
  providers: [ MatDialogModule,{provide: MAT_DATE_LOCALE, useValue: 'en-GB'}, {provide : LocationStrategy, useClass : PathLocationStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule { }
